import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "nav nav-tabs border-0 mb-4 gap-3 categories-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_2 = ["id", "data-bs-target", "aria-controls", "aria-selected", "onClick"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "fs-16 fw-medium d-block mb-0" }
const _hoisted_5 = { class: "fs-12 fw-medium text-body" }
const _hoisted_6 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_7 = ["id", "aria-labelledby"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_10 = { class: "pb-1" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "fs-20 fw-medium mb-1" }
const _hoisted_13 = { class: "text-body" }
const _hoisted_14 = { class: "d-flex justify-content-between align-items-end" }
const _hoisted_15 = { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "fs-20 fw-medium mb-4" }, "Categories", -1)),
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
        return (_openBlock(), _createElementBlock("li", {
          key: category.id,
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link border-2 bg-transparent rounded-3", { active: category.id === _ctx.activeCategory }]),
            id: `${category.id}-tab`,
            "data-bs-toggle": "tab",
            "data-bs-target": `#${category.id}-tab-pane`,
            type: "button",
            role: "tab",
            "aria-controls": `${category.id}-tab-pane`,
            "aria-selected": category.id === _ctx.activeCategory,
            onClick: ($event: any) => (_ctx.setActiveCategory(category.id)),
            style: {"width":"125px","padding":"20px 20px 16px"}
          }, [
            _createElementVNode("img", {
              src: category.icon,
              class: "mb-3",
              alt: `${category.name}-icon`
            }, null, 8, _hoisted_3),
            _createElementVNode("h4", _hoisted_4, _toDisplayString(category.name), 1),
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.categoryCounts[category.id]) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "d-none" }, "Products", -1))
            ])
          ], 10, _hoisted_2)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
        return (_openBlock(), _createElementBlock("div", {
          key: category.id,
          class: _normalizeClass(["tab-pane fade", { 'show active': category.id === _ctx.activeCategory }]),
          id: `${category.id}-tab-pane`,
          role: "tabpanel",
          "aria-labelledby": `${category.id}-tab`,
          tabindex: "0"
        }, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductsByCategory(category.id), (product) => {
              return (_openBlock(), _createElementBlock("div", {
                key: product.id,
                class: "col-md-4 col-sm-6"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "d-block text-decoration-none mb-2"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: product.image,
                          class: "rounded-2 mb-3",
                          alt: product.name
                        }, null, 8, _hoisted_11),
                        _createElementVNode("h3", _hoisted_12, _toDisplayString(product.name), 1),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(product.category), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, " $" + _toDisplayString(product.price), 1),
                      _cache[1] || (_cache[1] = _createElementVNode("button", {
                        class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                        style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                      }, [
                        _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                      ], -1))
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]),
          _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap custom-shadow for-dark-rounded-bg rounded-3 border bg-white px-4 mb-4\" style=\"padding-top:11px;padding-bottom:11px;\"><span class=\"fs-12 fw-medium\">Showing 9 of 30 Results</span><nav aria-label=\"Page navigation example\"><ul class=\"pagination mb-0 justify-content-center\"><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Previous\"><i class=\"material-symbols-outlined\">keyboard_arrow_left</i></button></li><li class=\"page-item\"><button class=\"page-link active\">1</button></li><li class=\"page-item\"><button class=\"page-link\">2</button></li><li class=\"page-item\"><button class=\"page-link\">3</button></li><li class=\"page-item\"><a class=\"page-link\">4</a></li><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Next\"><i class=\"material-symbols-outlined\">keyboard_arrow_right</i></button></li></ul></nav></div>", 1))
        ], 10, _hoisted_7))
      }), 128))
    ])
  ]))
}